// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"358":"c95eb6ab","463":"0b0a1869"}[chunkId] + ".chunk.css";
};